// @flow
import * as React from 'react'
import getTrainCompanies from 'mz-sdk/services/train/getTrainCompanies'
import type { Train } from 'mz-sdk/services/train/getTrains'
import { FormattedMessage } from 'mz-intl'
import Row from '../../../core/Row'
import { wrapWithField } from '../../Field'
import SelectField from '../../SelectField/field'
import TrainNumberField from '../TrainNumberField'
import messages from '../messages.intl'

// Types
import type { Input } from '../../../core/BaseField'

export type Props = {
  input: Input,
  required?: boolean,
  nest: Function,
  trainInfo: TrainInfo,
}
export type TrainInfo = {
  pickupDatetime: string,
  stationCode: string,
  trainDirection: 'arr' | 'dep',
}
export type Value = {
  company?: string,
  train?: Train,
}

export function getTrainReservationData(train: ?Value, prefix: string = '') {
  if (!train) return null
  return {
    [`${prefix}train_company`]: train.company && train.company.toLowerCase(),
    [`${prefix}train_number`]: train.train?.train_number, // eslint-disable-line camelcase
  }
}

/**
 * A field that gives a way to select a cruise line
 * and enter ship name.
 */
const TrainField = ({ input, required, nest, trainInfo }: Props) => (
  <Row wrap="inf">
    <SelectField
      {...nest('company', { dependsOnValue: true })}
      searchable
      required={required}
      label={<FormattedMessage message={messages.COMPANY_LABEL} />}
      placeholder={<FormattedMessage message={messages.COMPANY_PLACEHOLDER} />}
      searchableOptions={{
        rememberInitialOptions: true,
        requestOptions: getTrainCompanies,
      }}
    />
    {!!(input.value && input.value.company) && (
      <TrainNumberField
        {...nest('train')}
        lightboxSubtitle={null}
        lightboxTitle={
          <FormattedMessage message={messages.TRAIN_LIGHTBOX_TITLE} />
        }
        label={<FormattedMessage message={messages.TRAIN_LABEL} />}
        placeholder={<FormattedMessage message={messages.TRAIN_PLACEHOLDER} />}
        required={required}
        trainInfo={trainInfo}
        disableFloatingLabel
      />
    )}
  </Row>
)

export default wrapWithField(TrainField)
